export default __webpack_public_path__ + "static/media/range-icon.b5d66201.svg";